// extracted by mini-css-extract-plugin
export default {"text":"hero_text__4Bul9"};